import { render } from "./TestInfoPopover.vue?vue&type=template&id=537afe94&scoped=true"
import script from "./TestInfoPopover.vue?vue&type=script&lang=js"
export * from "./TestInfoPopover.vue?vue&type=script&lang=js"

import "./TestInfoPopover.vue?vue&type=style&index=0&id=537afe94&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537afe94"]])

export default __exports__